// extracted by mini-css-extract-plugin
module.exports = {"input":"i_FL"};